import React from 'react';
import { useTranslate } from '@awardit/react-use-translate';
import { SupportSvg } from '../../../icons/index.js';
import styles from 'shop-views/CustomerServiceLink.scss';

var CustomerServiceLink = _ref => {
  var helpdesk = _ref.helpdesk;
  var t = useTranslate();
  var helpdeskLink = (helpdesk == null ? void 0 : helpdesk.link) !== undefined && helpdesk.link !== null ? helpdesk.link : t("CUSTOMER_SERVICE.LINK");

  if (!helpdeskLink || helpdeskLink === "/" || helpdeskLink === "[CUSTOMER_SERVICE.LINK]") {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.serviceLinkBlock
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.serviceLinkIcon,
    src: SupportSvg
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.serviceLinkText
  }, /*#__PURE__*/React.createElement("span", null, t("CHECKOUT.NEED_HELP")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    href: helpdeskLink,
    _target: "blank",
    rel: "noopener noreferrer"
  }, t("CHECKOUT.CONTACT_CUSTOMER_SERVICE"))));
};

export { CustomerServiceLink };
//# sourceMappingURL=index.js.map
